import React from 'react';
import { Svg, Path } from '@react-pdf/renderer';

const CheckboxUnchecked = () => (
  <Svg width="24" height="24" viewBox="0 0 24 24"><Path fill="black" d="M22 2v20h-20v-20h20zm2-2h-24v24h24v-24z"/></Svg>
);

export default CheckboxUnchecked;
